module.exports = __webpack_public_path__ + "static/media/download.8f650667.svg";